import styled from "styled-components";
import { breakpoints } from "../../../../shared-logic/themes/lexusTheme";

export const Wrapper = styled.div`
    margin: 0;
    padding-top: var(--spacing-4);
    padding-bottom: var(--spacing-6);
    color: var(--color-midnight);
    background-color: var(--color-white);
    border-top: 1px solid var(--color-platinum-medium);
`;

export const Content = styled.div`
    --disclaimer-content-padding: var(--spacing-3);
    padding-left: var(--disclaimer-content-padding);
    padding-right: var(--disclaimer-content-padding);
    font-size: 1.4rem;
    line-height: 1.57;

    @media screen and (min-width: ${breakpoints.xxl}) {
        --disclaimer-content-padding: var(--spacing-7);
    }

    @media screen and (min-width: ${breakpoints.max}) {
        --disclaimer-content-padding: 0;
    }
`;

export const Title = styled.div`
    margin-bottom: var(--spacing-2);
    font-family: var(--font-book);
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    line-height: 3rem;
    text-transform: uppercase;
    color: var(--color-midnight);
`;
